<div class="testimony-home">
  <div class="testimony-home__header">
    <div>
      <h1 class="page-title">Testimonies</h1>
      <p class="page-subtitle">Create testimony reports from delivered requests, then review draft and submitted reports.</p>
    </div>
    <div class="testimony-home__segmented" role="tablist" aria-label="Testimony views">
      <button
        type="button"
        role="tab"
        [attr.aria-selected]="activeView === 'testimonies'"
        [class.is-active]="activeView === 'testimonies'"
        (click)="setView('testimonies')">
        <span>Testimonies</span>
        <span class="testimony-home__segment-count">{{ testimonyState.followupPagination().total }}</span>
      </button>
      <button
        type="button"
        role="tab"
        [attr.aria-selected]="activeView === 'reports'"
        [class.is-active]="activeView === 'reports'"
        (click)="setView('reports')">
        <span>Reports</span>
        <span class="testimony-home__segment-count">{{ testimonyState.reportPagination().total }}</span>
      </button>
    </div>
  </div>

  @if (activeView === 'testimonies') {
  <app-table
    [data]="testimonyState.followups()"
    [columns]="followupColumns"
    [config]="followupConfig"
    [pagination]="followupPagination"
    (sortChange)="onSortChange($event)"
    (pageChange)="onFollowupPageChange($event)"
    (pageSizeChange)="onFollowupPageSizeChange($event)"
    (actionClick)="onActionClick($event)"
    (searchChange)="onFollowupSearchChange($event)"></app-table>
  } @else {
  <app-table
    [data]="testimonyState.reports()"
    [columns]="reportColumns"
    [config]="reportConfig"
    [pagination]="reportPagination"
    (sortChange)="onSortChange($event)"
    (pageChange)="onReportPageChange($event)"
    (pageSizeChange)="onReportPageSizeChange($event)"
    (actionClick)="onActionClick($event)"
    (searchChange)="onReportSearchChange($event)"
    (filterChange)="onReportFilterChange($event)"></app-table>
  }
</div>
